// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.applyOffsetHeader
{
    background-color: #202020;
    width: 95%;
    height: 30px;
    border-radius: 4px;
    margin-left: 3%;
    margin-top: 5px;
    margin-bottom: 5px;
}

.applyOffsetBody
{
    background-color: black;
    border-radius: 4px;
    width: 95%;
    margin-left: 3%;
    height: calc(100% - 40px);
    overflow-y: scroll;
    /* Chrome, Edge, Safari */
    scrollbar-width: none;      /* Firefox */
    -ms-overflow-style: none;   /* IE/Edge old */    
}

.applyOffsetBody::-webkit-scrollbar {
  display: none;              /* Chrome, Safari, Edge */
}

.applyOffsetLabel
{
    color: gray;
    padding-left: 10px;
    font-size: 14px;
}

.applyOffsetText
{
    color: white;
    padding-left: 10px;
    font-size: 14px;
}


.applyOffsetTrAssetTitle
{
    
    color:white;
    padding-bottom: 5px;
    
}

.applyOffsetTrAssetLine
{
    background-color: transparent;
}

.applyOffsetTdAssetLine
{
    justify-content: center; /* horizontal */
    vertical-align: center;
    text-align: center;
    padding-left: 3px;
    padding-right: 3px;
}

.applyOffsetTdProcessing
{
    background-color: #0000B0;
    border-radius: 4px;
}

.applyOffsetTdDone
{
    background-color: #006000;
    border-radius: 4px;
}`, "",{"version":3,"sources":["webpack://./src/applications/dialogs/applyoffsetvideo.css"],"names":[],"mappings":"AAAA;;IAEI,yBAAyB;IACzB,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,kBAAkB;AACtB;;AAEA;;IAEI,uBAAuB;IACvB,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB,OAAO,YAAY;IACxC,wBAAwB,IAAI,gBAAgB;AAChD;;AAEA;EACE,aAAa,eAAe,yBAAyB;AACvD;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;IAEI,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;;AAGA;;;IAGI,WAAW;IACX,mBAAmB;;AAEvB;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;;IAEI,uBAAuB,EAAE,eAAe;IACxC,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;IAEI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;;IAEI,yBAAyB;IACzB,kBAAkB;AACtB","sourcesContent":[".applyOffsetHeader\n{\n    background-color: #202020;\n    width: 95%;\n    height: 30px;\n    border-radius: 4px;\n    margin-left: 3%;\n    margin-top: 5px;\n    margin-bottom: 5px;\n}\n\n.applyOffsetBody\n{\n    background-color: black;\n    border-radius: 4px;\n    width: 95%;\n    margin-left: 3%;\n    height: calc(100% - 40px);\n    overflow-y: scroll;\n    /* Chrome, Edge, Safari */\n    scrollbar-width: none;      /* Firefox */\n    -ms-overflow-style: none;   /* IE/Edge old */    \n}\n\n.applyOffsetBody::-webkit-scrollbar {\n  display: none;              /* Chrome, Safari, Edge */\n}\n\n.applyOffsetLabel\n{\n    color: gray;\n    padding-left: 10px;\n    font-size: 14px;\n}\n\n.applyOffsetText\n{\n    color: white;\n    padding-left: 10px;\n    font-size: 14px;\n}\n\n\n.applyOffsetTrAssetTitle\n{\n    \n    color:white;\n    padding-bottom: 5px;\n    \n}\n\n.applyOffsetTrAssetLine\n{\n    background-color: transparent;\n}\n\n.applyOffsetTdAssetLine\n{\n    justify-content: center; /* horizontal */\n    vertical-align: center;\n    text-align: center;\n    padding-left: 3px;\n    padding-right: 3px;\n}\n\n.applyOffsetTdProcessing\n{\n    background-color: #0000B0;\n    border-radius: 4px;\n}\n\n.applyOffsetTdDone\n{\n    background-color: #006000;\n    border-radius: 4px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
